import api from './api';

const expenseTypeService = {
  getAll: async (category = null) => {
    const url = category
      ? `/api/expense-types?category=${encodeURIComponent(category)}`
      : '/api/expense-types';
    const response = await api.get(url);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/api/expense-types', data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/api/expense-types/${id}`);
    return response.data;
  },
};

export default expenseTypeService;